
import './App.css';

import Navigation from './components/navigation';
import HeroSection from './components/hero';
const App = () =>{
  return (
    <div className="App">
      <Navigation/>
      <HeroSection/>
      
    </div>
  );
}

export default App;
